import React, { Component } from 'react';
import { Row, Col, Popover, Form, Input, Cascader, Button, Divider, Modal, message, Select } from 'antd';
import EventSet from "./../../../../../assets/PubJs/hcPub"//公用的所有事件
import $, { type } from "jquery"
import createHistory from 'history/createHashHistory';//路由切换地址
import { Hcurl } from "./../../../../../constants/index"//获取公共路径
import { connect } from "react-redux"//联系store的组件
import evn from "./../../../../../actions/index"//action的所有事件
import { setTimeout } from 'core-js/library/web/timers';

const FormItem = Form.Item;
const { TextArea } = Input;
const confirm = Modal.confirm;
const history = createHistory();//定义history路由
const Option = Select.Option;
var click= true
var clickC = true
var zishu = 0;	


//富文本编辑
var _Ueditor = '';
var editor = '';
var flag = '';
class Ueditor extends React.Component {
    state = {
        ContentLength: null,
        UeditorContent: ""
    };
    initEditor() {
        editor = UE.getEditor(this.props.id, {
            //工具栏
            toolbars: [
                ['fullscreen', 'source', '|', 'undo', 'redo', '|',
                    'bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
                    'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
                    'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
                    'directionalityltr', 'directionalityrtl', 'indent', '|',
                    'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
                    'link', 'unlink', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
                    'insertimage', 'emotion', 'insertcode', 'pagebreak', '|',
                    'horizontal', 'spechars', '|',
                    'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts', '|',
                    'preview']
            ]
            , lang: "zh-cn"
            //字体
            , 'fontfamily': [
                { label: '', name: 'songti', val: '宋体,SimSun' },
                { label: '', name: 'kaiti', val: '楷体,楷体_GB2312, SimKai' },
                { label: '', name: 'yahei', val: '微软雅黑,Microsoft YaHei' },
                { label: '', name: 'heiti', val: '黑体, SimHei' },
                { label: '', name: 'lishu', val: '隶书, SimLi' },
                { label: '', name: 'andaleMono', val: 'andale mono' },
                { label: '', name: 'arial', val: 'arial, helvetica,sans-serif' },
                { label: '', name: 'arialBlack', val: 'arial black,avant garde' },
                { label: '', name: 'comicSansMs', val: 'comic sans ms' },
                { label: '', name: 'impact', val: 'impact,chicago' },
                { label: '', name: 'timesNewRoman', val: 'times new roman' }
            ]
            //字号
            , 'fontsize': [10, 11, 12, 14, 16, 18, 20, 24, 36]
            , initialFrameHeight: 400
            , enableAutoSave: false
            , autoHeightEnabled: false
            //, initialFrameHeight: this.props.height
            , initialFrameWidth: '100%'
            , wordCount: true  //是否开启字数统计
            , maximumWords: 10000,
            //, readonly: this.props.disabled
        });
        var me = this;
        editor.ready(function (ueditor) {
            editor.setContent(_Ueditor.state.UeditorContent);
        });
        editor.addListener("selectionchange", function () {
            var editorValue = editor.getContent();//获取富文本内内容
            var hasContents = editor.hasContents();//判断富文本内 是否有内容
            zishu = editor.getContentTxt().length;
            _Ueditor.setState({ ContentLength: editor.getContentLength(true) })
       
        });
    }
    componentWillMount() {

    }
    componentDidMount() {
        _Ueditor = this;
        this.initEditor()
    }
    componentWillUnmount() {
        // 组件卸载后，清除放入库的id
        UE.delEditor(this.props.id);
    }
    componentWillMount() {

    }

    render() {
        return (
            <div id={this.props.id} name={this.props.id} type="text/plain"></div>
        )
    }
}


//进度查询内容
let _Contents = null;
class Contents extends React.Component {
    state = {
        // type : 1,
        visible: false,
        data: [],
        con: {
            type: "",
            person: "",
            beginTime: "",
            contents1Name: '',
            contents1Header: '',
            contents1Phone: '',
            endTime: "",
            contents2:""
        }
    };
    showModal = (e) => {
        //console.log(e)
        let con = {
            type: e.CA_IsComUserCancel === 1 ? "已撤销" : (e.CA_IsDeal === 0 ? "待回复" : "已回复"),
            person: e.CU_UserName,
            beginTime: e.CA_ApplyTime.replace("T", " "),
            contents1Name: e.CA_ComSimpleName,
            contents1Header: e.CA_ComHeader,
            contents1Phone: e.CA_ComPhone,
            endTime:  e.CA_DealTime === null ? "-" : (e.CA_DealTime === "" ? "-" : e.CA_DealTime) ,
            contents2: e.CA_DealAdvice === null ? "-" : (e.CA_DealAdvice === "" ? "-" : e.CA_DealAdvice),
        }
        this.setState({
            visible: true,
            con
        });
        _AlwayUseForm.setState({
            visible: false,
        });
    };
    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };
    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    };

    componentDidMount() {
        _Contents = this;

    }
    render() {
        return (
            // , overflowY:"auto" 
            <div style={{ maxHeight: "480px"}}>
                <Modal
                    title="详细内容"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    width={720}
                    footer={null}
                >
                    <Row>
                        <Col style={{ marginBottom: 18 }} span={24}> <span style={{ color: "#989898" }}>处理进度：</span>{this.state.con.type}</Col>
                        <Col style={{ marginBottom: 18 }} span={12}><span style={{ color: "#989898" }}>送审人：</span>{this.state.con.person}</Col>
                        <Col style={{ marginBottom: 18 }} span={12}><span style={{ color: "#989898" }}>送审时间：</span>{this.state.con.beginTime}</Col>
                        <Col style={{ marginBottom: 18 }} span={24}><span style={{ color: "#989898" }}>送审内容：</span>
                            <hr />
                                <Row>
                                    <Col style={{ marginBottom: 18 }} span={24}><span style={{ color: "#989898" }}>企业别称:</span>{this.state.con.contents1Name}</Col>
                                    <Col style={{ marginBottom: 18 }} span={24}><span style={{ color: "#989898" }}>联系对象:</span>{this.state.con.contents1Header}</Col>
                                    <Col style={{ marginBottom: 18 }} span={24}><span style={{ color: "#989898" }}>联系电话:</span>{this.state.con.contents1Phone}</Col>
                                </Row>
                            <hr />
                        
                        
                        </Col>
                        <Col style={{ marginBottom: 18 }} span={24}><span style={{ color: "#989898" }}>回复时间：</span>{this.state.con.endTime}</Col>
                        <Col style={{ marginBottom: 18 }} span={24}><span style={{ color: "#989898" }}>回复内容：</span>{this.state.con.contents2}</Col>
                    </Row>
                </Modal>
                <div style={{ display: _AlwayUseForm.state.data.length === 0 ? "block" : "none" }} className={"jdcx"}>
                    <p style={{ textAlign:"center" }}>暂无送审记录</p>
                </div>
                {
                    _AlwayUseForm.state.data.map(function (e) {
                        return (
                            <div key={e.ID} className={"jdcx"}>
                                {/* #ff4d4f   "#00CC99" */}
                                <p>处理进度: <span style={{ color: e.CA_IsComUserCancel === 1 ? "#999" : (e.CA_IsDeal === 0 ? "#1890FF" :(e.CA_DealResult === 2 ? "#ff4d4f": "#00CC99") ) }}>{e.CA_IsComUserCancel === 1 ? "已撤销" : (e.CA_IsDeal === 0 ? "待回复" : (e.CA_DealResult === 1 ?  "已通过": "未通过"))}</span></p>
                                <p>申诉时间: <span>{e.CA_ApplyTime.replace("T"," ")}</span></p>
                                <p>回复时间: <span>{e.CA_DealTime === null ? "-" : (e.CA_DealTime === "" ? "-" : e.CA_DealTime)}</span></p>
                                <p style={{display: e.CA_DealResult === 2 ? "block" : "none" }}>详细内容: <a onClick={() => _Contents.showModal(e)}>点击查看</a></p>
                            </div>
                        )
                    })
                }
            </div>
        )
    }
}

//表单
let _AlwayUseForm = null;
class AlwayUseForm extends React.Component {
    state = {
        values: "",
        visible: false,
        area: [],
        areaArr: [],
        shenshu: "",
        data:[],
        value2:'',
    };

    //设置表单默认值
    setInitialValue = (news) => {
        console.log(news,"news")
        let _this = this;

        let CA_ComHeader = news.CA_ComHeader !== '' ? news.CA_ComHeader : news.Header;
        let CA_ComPhone = news.CA_ComPhone !== '' ? news.CA_ComPhone : news.Phone;
        let CA_ComSimpleName = (news.CA_ComSimpleName !== '' &&news.CA_ComSimpleName !=null)? news.CA_ComSimpleName.split(';') : (news.SimpleName == "" || news.SimpleName == null) ? [] : news.SimpleName.split(";");
        console.log(CA_ComSimpleName)
        this.setState({
            shenshu: news.IsDeal === "1" ? "1" : news.IsComUserCancel
        })
        // let type = news.CompanyOrganizeType.split(";")  type[type.length - 1],
        _this.props.form.setFieldsValue({
            xydm: news.CreditCode,
            qymc: news.CompanyName,
            qyjb: news.CompanyLevel,
            qyjglx: news.CompanyOrganizeType,
            zgbm: news.DepartMent,
            qyxyf: news.CreditPoint == "" ? "-" : news.CreditPoint,
            qybc: CA_ComSimpleName,
            //szdq: _this.getAreaCode(news.Area),
            //xxdz: news.Address,
            lxdx: CA_ComHeader,
            lxdh: CA_ComPhone,
        })
        if(news.IsComUserCancel == 0 && news.IsDeal == 0 &&news.DealID > 0) {
            this.setState({btnStatus: true});
        }else {
            this.setState({btnStatus: false});
        }

    }

    //遍历地区code
    getAreaCode = (area) => {
        let arr=[]
        for (let i = 0; i < area.length; i++) {
            arr[i] = area[i].SA_Code
        }
        return arr
    }

    //点击申述
    Statement = () => {
        
        _SsModal.showModal()
    };

    //显示记录
    handleVisibleChange = (visible) => {
        if (visible) {
            let setData = {
                UserCode: EventSet.getUserInfo().CU_Code,
                CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
                Sort: '1',
                type: "5"
            };
            $.ajax({
                url: Hcurl+"/CompanyCore/ProgressQuery",
                type: "post",
                data: setData,
                async: false,
                headers: {
                    "token": EventSet.getUserInfo()['token']
                },
                success: function (res) {
                    console.log(res)
                    _AlwayUseForm.setState({
                        visible,
                        data: JSON.parse(res)
                    });
                },
                error: function (data, err) {
                    if (!JSON.parse(data.responseText).success && data.status === 403) {
                        history.push({ "pathname": "/err" })
                    } else {
                        message.error(err)
                    }
                }
            })
        } else {
            _AlwayUseForm.setState({ visible });
        }
    };

    //绑定企业组件表单提交
    handleSubmit = () => {
       
            let _this = this;
            this.props.form.validateFields((err, values) => {
                //console.log(values.qybc.length)
                if (JSON.parse(localStorage.getItem('companyInfo')).UCR_IsAdmin != 1) {
                    message.error("权限不足，只有管理员可更改！")
                    return
                }
                if (!err) {
                    if (values.qybc.length>20) {
                        message.error("20ge")
                        return
                    }
                    let setData = {
                        UserCode: EventSet.getUserInfo().CU_Code,
                        CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
                        SimpleName: values.qybc.toString().replace(/,/g, ";"),
                        //Area: values.szdq.toString(),
                        //Address: values.xxdz,
                        ComHeader: values.lxdx,
                        ComPhone: values.lxdh,
                        Sort: "3",
                        type: '3'
                    };
                    //console.log(setData)
                    if(click){
                        click =false
                    $.ajax({
                        url: Hcurl+"/CompanyCore/UserComplaint",
                        type: "post",
                        data: setData,
                        async: false,
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        success: function (res) {
                            if (res.split("|")[0] === "true") {
                                message.success(res.split("|")[1])
                                _this.getInformation()
                            } else {
                                message.error(res.split("|")[1])
                            }
                            setTimeout(() => {
                                click = true
                            }, 2000);
                        },
                        error: function (data, err) {
                            if (!JSON.parse(data.responseText).success && data.status === 403) {
                                history.push({ "pathname": "/err" })
                            } else {
                                message.error(err)
                            }
                        }
                    })
                }
                } else {
                    message.warn("请检查后重新尝试")
                }
            });
        
    };

// 送审函数

  //保存并送审
submit = (value) => {
    console.log(value)
    let _this = this;
    if (JSON.parse(localStorage.getItem('companyInfo')).UCR_IsAdmin != 1) {
        message.error("权限不足，只有管理员可更改！")
        return
    }
    confirm({
        title: '提示',
        content: '企业信息变更需要审核，在审核周期内无法再次进行更改，确定执行“保存并送审”操作吗？',
        onOk:()=>{this.handleSubmit()},
        okText:'确定',
        cancelText:'取消'
    });
}

//撤回送审
handleback= () => {
    
   
        let _this = this;
        if (JSON.parse(localStorage.getItem('companyInfo')).UCR_IsAdmin !=1) {
            message.error("权限不足，只有管理员可更改！")
            return
        }
        confirm({
            title: '提示',
            content: '确定要撤销本次“企业信息”变更送审操作吗？',
            okText:'确定',
            cancelText:'取消',
            onOk() {
                let setData = {
                    UserCode: EventSet.getUserInfo().CU_Code,
                    CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code,
                    Sort: "3",
                    type: "4"
                };
                if(clickC){
                    clickC =false
                    $.ajax({
                        url: Hcurl + "/CompanyCore/UserComplaint",
                        type: "post",
                        data: setData,
                        async: false,
                        headers: {
                            "token": EventSet.getUserInfo()['token']
                        },
                        success: function (res) {
                            if (res.split("|")[0] === "true") {
                                message.success(res.split("|")[1])
                                console.log('删除成功')
                                _this.getInformation()
                                // location.reload([false])
                            } else {
                                message.error(res.split("|")[1])
                            }
                            setTimeout(() => {
                                clickC = true
                            }, 2000);
                        },
                        error: function (data, err) {
                            if (!JSON.parse(data.responseText).success && data.status === 403) {
                                history.push({ "pathname": "/err" })
                            } else {
                                message.error(err)
                            }
                        }
                    })
                }
            },
            onCancel() {
            },
        });
    

}

// 送审函数
    //获取企业基本信息
    getInformation() {
        let _this = this;
        let setData = {
            UserCode: EventSet.getUserInfo().CU_Code, //20200710000001
            CompanyCode: JSON.parse(localStorage.getItem('companyInfo')).Com_Code, //20200701000001
        };
        $.ajax({
            url: Hcurl+"/CompanyCore/CompanyInfoShow",
            type: "post",
            data: setData,
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                console.log(res)
                _this.setInitialValue(JSON.parse(res))
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })
        // 
        $.ajax({
            url: Hcurl+"/CompanyCore/GetAreaTreeSource",
            type: "post",
            data: {},
            async: false,
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            success: function (res) {
                _this.setState({
                    area: JSON.parse(res)
                })
            },
            error: function (data, err) {
                if (!JSON.parse(data.responseText).success && data.status === 403) {
                    history.push({ "pathname": "/err" })
                } else {
                    message.error(err)
                }
            }
        })

    }

    //Tag改变
    handleTagChange = (rule, value, callback) => {
        console.log(value);
        if (value.toString().split(",").length > 20) {
            callback("请输入20个以内标签")
        } else {
            if (value.toString().length > 200) {
                callback("标签总字数控制在200字以内")
            } else {
                callback()
            }
        }
    }

    
    //组件完成
    componentDidMount() {
        _AlwayUseForm = this;
        this.getInformation()
        $(".ant-cascader-picker-label").hover(function () {
            $(this).attr("title", $(this).text())
        })
    }

    //表单内容
    getFields() {
        const { getFieldDecorator } = this.props.form;
        return (
            <Row gutter={24}>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="信用代码"
                    >
                        {getFieldDecorator('xydm', {
                            initialValue: this.state.values
                        })(
                            <Input disabled />
                            )}
                    </FormItem>
                </Col>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="企业名称"
                    >
                        {getFieldDecorator('qymc')(
                            <Input disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="企业级别"
                    >
                        {getFieldDecorator('qyjb')(
                            <Input disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="企业机构类型"
                    >
                        {getFieldDecorator('qyjglx')(
                            <Input disabled />
                        )}
                    </FormItem>
                </Col>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="直属部门"
                    >
                        {getFieldDecorator('zgbm')(
                            <Input disabled />
                        )}
                    </FormItem>
                </Col>
                {/* <Col xxl={8} xl={12}>
                    <Row>
                        <Col xxl={17} xl={18}>
                            <FormItem
                                label="企业信用分"
                            >
                                {getFieldDecorator('qyxyf')(
                                    <Input disabled />
                                )}
                            </FormItem>
                        </Col>
                        <Col xxl={7} xl={6}>
                            <div id={"jdcx"} style={{ lineHeight: "40px", height: "40px", marginLeft: "6px" }}>
                                {
                                    this.state.shenshu === "0" ? <a style={{ color: "red" }} onClick={this.Revoke}>撤销</a> : <a onClick={this.Statement}>申诉</a>
                                }
                                <Divider type="vertical" />
                                <Popover visible={this.state.visible}
                                    onVisibleChange={this.handleVisibleChange}
                                    placement="topLeft" title={<span>申诉记录</span>}
                                    content={<Contents />}
                                    trigger="click"
                                >
                                    <a >进度查询</a>
                                </Popover>
                            </div>
                        </Col>
                    </Row>
                </Col> */}
                {/* <Col xxl={24} xl={24} lg={24} > */}
                <Col xxl={24} xl={24}>
                    <FormItem
                        label="企业别称"
                    >
                        {getFieldDecorator('qybc', {
                            rules: [{ validator: this.handleTagChange}]
                        })(
                            <Select
                                mode="tags"
                                style={{ width: '100%' }}
                                placeholder="企业别称及品牌名称，每个别称输入完成可通过“回车键”进行下一个别称输入"
                                // onChange={this.handleTagChange}
                            >
                            </Select>,
                            //<Input maxLength={200} placeholder={"请输入企业别称或其下相关品牌名称，多个名称请以分号“；”隔开"} />
                        )}
                    </FormItem>
                </Col>

                {/*
                 *                 <Col xxl={8} xl={12}>
                    <FormItem
                        label="所在地区"
                    >
                        {getFieldDecorator('szdq', {

                            rules: [{ type: 'array', required: true, message: '请选择地区' }],
                        })(
                            <Cascader allowClear={false} placeholder={"请选择"} options={this.state.area} />
                            )}
                    </FormItem>
                </Col>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="详细地址"
                    >
                        {getFieldDecorator('xxdz', {
                            rules: [{ required: true, message: "请输入详细地址" }]
                        })(
                            <Input placeholder={"请输入详细地址"} />
                            )}
                    </FormItem>
                </Col>
                 */}
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="联系对象"
                    >
                        {getFieldDecorator('lxdx', {
                            rules: [
                                { required: true, message: "请输入联系对象" }
                            ]
                        })(
                            <Input maxLength={50} placeholder={"请输入联系对象"} />
                            )}
                    </FormItem>
                </Col>
                <Col xxl={8} xl={12}>
                    <FormItem
                        label="联系电话"
                    >
                        {getFieldDecorator('lxdh', {
                            rules: [
                                { required: true, message: "请输入联系电话" },
                                { pattern: /^[0-9]{6,18}$/, message: '请输入有效的电话号码' }
                                // {   max:18, min:6    }
                            ]
                        })(
                            <Input placeholder={"请输入联系电话"}  maxLength={'18'}/>
                            )}
                    </FormItem>
                </Col>
                <Col xxl={24} xl={24}>
                {/* <Ueditor id="details" dataValue={this.state.value2} /> */}
                </Col>
            </Row>
        );
    }

    //渲染
    render() {
        return (
            <div>
                <Form
                    style={{ position: "relative" }}
                    className="ant-advanced-search-form"
                >
                    <Row gutter={24}>{this.getFields()}</Row>
                </Form>
                <div style={{ textAlign: "left",color:'#b0b0b0',margin:'10px 0 30px  0' }}>
                    注：企业信息变更需要审核,请谨慎填写;如审核失败，请点击右下角"送审记录"查看失败原因
                    {/* <Button onClick={this.handleSubmit} htmlType="submit" type="primary">保存</Button> */}
                </div>
                {/* 添加送审代码 */}
                <p style={{ position: "relative" }}>
                {this.state.btnStatus === false ?<Button onClick={this.submit} htmlType="submit" type="primary">保存并送审</Button> : null}
                {this.state.btnStatus === true ?<Button type="primary" disabled>送审中...</Button> : null}
                {this.state.btnStatus === true ? <Button onClick={this.handleback} style={{ marginLeft: "12px", display: "inline-block" }} type="danger">撤销本次送审</Button> : null}
                    <Popover 
                        // visible={this.state.visible}
                        onVisibleChange={this.handleVisibleChange}
                        // onClick={this.handleVisibleChange}
                        placement="topLeft" title={<span>送审记录</span>}
                        content={<Contents />}
                        trigger="click"
                    >
                        <a style={{ position: "absolute", right: 0, bottom: 0 }}>送审记录</a>
                    </Popover>
                </p>
            </div>
        );
    }
}
const WrappedAlwayUseForm = Form.create()(AlwayUseForm);


// 送审函数



// 送审函数
//Tab--企业成员组件
class TabInformation extends Component {
    render() {
        return (
            <div className={"TabInformation"}>
                {/* <SsModal /> */}
                <Row>
                    <Col span={20} offset={2}><WrappedAlwayUseForm /></Col>
                </Row>
                
            </div>
        )

    }
}
export default connect()(TabInformation)



// WEBPACK FOOTER //
// ./src/components/Content/Business/CompanyCenter/CompanyListTab/TabInformation.js